import { PatientStatus } from '@truepill/tpos-types'

const inactivePatientStatuses = [PatientStatus.Inactive, PatientStatus.Merged]

// if patient status is not explicitly recorded, consider active
const isActivePatient = (patientStatus: PatientStatus | undefined): boolean =>
  !patientStatus || !inactivePatientStatuses.includes(patientStatus)

export default isActivePatient
